import styled from "styled-components";

export const IconsBarArea = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px auto 16px;
  padding: 8px 12px;
  max-width: 1280px;
  width: calc(100% - 24px);
  border-radius: 999px;
  background: #f2f4f7;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);
  overflow-x: hidden;
  gap: 8px;

  a {
    text-decoration: none;
    text-align: center;
    min-width: 70px;
    padding: 8px 10px;
    border-radius: 999px;
    color: #4A90E2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    opacity: 0.7;
    transition: all 0.18s ease-out;
  }

  a svg {
    flex-shrink: 0;
    color: inherit;
  }

  a:hover {
    opacity: 1;
    transform: translateY(-1px);
  }

  a.active {
    opacity: 1;
    background: #ffffff;
    color: #0b4f6c;
  }

  @media only screen and (max-width: 768px) {
    justify-content: flex-start;
    padding: 8px 10px;
    overflow-x: auto;
  }
`;

export const LabelIcon = styled.p`
  font-size: 11px;
  font-weight: 600;
  color: inherit;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

